import React, { useEffect } from 'react';

const PropagationBanner = ({ message, onDismiss }) => {
  useEffect(() => {
    if (!message) {
      return undefined;
    }
    const timer = setTimeout(() => {
      onDismiss();
    }, 8000);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  if (!message) {
    return null;
  }

  return (
    <div className="runtime-config-banner runtime-config-banner-success" role="status" data-testid="propagation-banner">
      {message}
    </div>
  );
};

export default PropagationBanner;
